import { Fragment, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch } from "react-redux";

import profileApi from "../api/profile";
import { sendError } from "../errors";
import i18n from "../i18n";
import { setLoading } from "../store";

import BigDot from "./BigDot.jsx";
import ListItem from "./ListItem.jsx";

export default function QualificationDisplay(props) {
  const dispatch = useDispatch();
  const [data, setData] = useState(props.user);

  useEffect(async () => {
    if (props.user) {
      return;
    }

    dispatch(setLoading(true));
    let result;
    try {
      result = await profileApi.me();
      setData(result);
    } catch (err) {
      sendError(err);
    }
    dispatch(setLoading(false));
  }, []);

  if (!data) {
    return <div></div>;
  }

  let universityDegreeColor = null;
  if (data.universityDegreeRecognized.valid) {
    universityDegreeColor = "success";
  } else {
    universityDegreeColor = "failure";
  }
  if (data.universityDegreeRecognized.warning) {
    universityDegreeColor = "warning";
  }

  let universityRecognizedColor = null;
  if (data.universityRecognized.valid) {
    universityRecognizedColor = "success";
  } else {
    universityRecognizedColor = "failure";
  }
  if (data.universityRecognized.warning) {
    universityRecognizedColor = "warning";
  }

  return (
    <Fragment>
      {data.university && data.university !== "unknown" && (
        <ListItem
          bold
          secondLine={
            <span>
              <BigDot color={universityRecognizedColor} small />
              {data.universityRecognized.message}
            </span>
          }
        >
          {data.university}
        </ListItem>
      )}
      {data.universityDegree && data.universityDegree !== "unknown" && (
        <ListItem
          bold
          secondLine={
            <span>
              <BigDot color={universityDegreeColor} small />
              {data.universityDegreeRecognized.message}
            </span>
          }
        >
          {data.universityDegree}
        </ListItem>
      )}
    </Fragment>
  );
}
